import BasePartner from './BasePartner'
import appUserService from '../../../services/appUserService'

const PAYMENT_TYPE_VIETTEL_MONEY_GATEWAY = 15
const PAYMENT_QR_METHOD_VTMxTAMOVE = 16

export default class ViettelMoneyPartner extends BasePartner {
  getAllowRenew() {
    return 1
  }

  getCreateOrderPaymentMethodData() {
    return {
      paymentMethodType: PAYMENT_TYPE_VIETTEL_MONEY_GATEWAY,
      paymentMethodId: PAYMENT_QR_METHOD_VTMxTAMOVE
    }
  }

  getCreatePaymentMethodData() {
    return {
      paymentMethodType: PAYMENT_TYPE_VIETTEL_MONEY_GATEWAY,
      paymentMethodId: PAYMENT_QR_METHOD_VTMxTAMOVE
    }
  }

  async beforePayment({ orderId, phoneNumber, setIsSubmitting, setErrorMessage, redirectToExternalPayment }) {
    setIsSubmitting(true)
    const linkedResponse = await appUserService.viettelMoneyAPIInitializeLink({
      username: phoneNumber,
      orderId: orderId
    })

    if (linkedResponse?.statusCode !== 200) {
      setIsSubmitting(false)
      setErrorMessage({
        title: 'Liên kết thất bại',
        content: 'Liên kết tài khoản thất bại, vui lòng thử lại.'
      })
      return false
    }

    if (linkedResponse?.data?.isLinked) {
      setIsSubmitting(false)
      return true
    }

    if (linkedResponse?.data?.deepLink) {
      redirectToExternalPayment(linkedResponse.data.deepLink)
      return false
    }

    setIsSubmitting(false)
    setErrorMessage({
      title: 'Liên kết thất bại',
      content: 'Không thể kiểm tra liên kết tài khoản. Vui lòng thử lại.'
    })
    return false
  }

  handlePostPaymentResponse({ paymentResponse, setIsSubmitting, redirectToExternalPayment, setErrorMessage }) {
    const paymentDeepLink = paymentResponse?.data?.paymentDeepLink
    
    if (typeof paymentDeepLink === 'string' && paymentDeepLink.startsWith('https://')) {
      redirectToExternalPayment(paymentDeepLink)
      return { handled: true }
    }

    setIsSubmitting(false)
    setErrorMessage({
      title: 'Thanh toán thất bại',
      content: 'Không thể khởi tạo liên kết thanh toán Viettel Money. Vui lòng thử thanh toán lại.'
    })
    return { handled: true }
  }
}
